<template>
    <div class="chat-initial">
        <header-game 
            :score="score" 
            v-if="routeName != 'chat'" 
            :loader="loader" 
            view="chat" 
            :chatInitial="true" 
            :showScore="false" 
            typeInfo="clock" 
            :clockTime="clock"></header-game>
        <chat :chatId="chatId"></chat>
    </div>
</template>
<script>
import Chat from '../../Chat.vue'
import HeaderGame from '../Sections/HeaderGame.vue'
import decodeApi from "../../api/decode"
export default {
    components: {
        Chat,
        HeaderGame
    },
    props:{
        loader : {
            type : Boolean
        },
        timeToInit : {
            type : String
        },
        score : {
            
        },
        timer : {

        }
    },
    data(){
        return{
            chatId : '',
            routeName : ''
        }
    },
    computed:{
        clock(){
            return this.timer ? this.timer : this.timeToInit
        }
    },
    created(){
        this.chatId = localStorage.getItem('chatId')
        this.routeName = this.$route.name
    },
    methods : {
        async sendMessage(){
            const { player, chatId } = await this.$store.getters.getSimple(['player', 'chatId'])
            // const { player, chatId } = await undefined
            let message = this.$refs.inputMessage.value
            let newMessage = {
                message,
                name : player.name,
                sendlerId : player.id,
                chatId : this.chatId
            }
            try {
                this.socket.emit('saveMessage', chatId, newMessage)
            } catch (error) {
                //TODO: make a error message showing up instead console.log error
                // console.error("error on socket: ", error)
                let { teamGameId, groupId, group, userId } = await this.$store.getters.getSimple(['teamGameId', 'groupId', 'group', 'userId'])
                let errorBody = { teamGameId, groupId, group, userId }
                errorBody.workspaceId = localStorage.getItem("workspaceId")
                errorBody.firebaseError = error
                errorBody.line = "66"
                errorBody.file = "ChatInitial.vue"
                // console.log("errorBody: ", errorBody)
                
                const { data: res } = await decodeApi.post(`/logs`,errorBody)
            }
        }
    }
}
</script>
<style>

</style>
